import { useSimulationStore } from '../../stores/useSimulationStore';
import styles from './Simulation.module.css';

const ESCROW = '__escrow__';

function formatAddr(addr: string): string {
  if (addr === ESCROW) return 'Escrow';
  if (addr.length > 16) return `${addr.slice(0, 8)}…${addr.slice(-4)}`;
  return addr;
}

export function BalanceView() {
  const currentBalances = useSimulationStore(s => s.currentBalances);
  const result = useSimulationStore(s => s.result);
  const currentStep = useSimulationStore(s => s.currentStep);

  // Compute previous balances for change highlighting
  const prevBalances = result && currentStep >= 0
    ? result.steps[currentStep].balancesBefore
    : null;

  const rows: { address: string; asset: string; balance: number; change: number }[] = [];

  for (const addr of Object.keys(currentBalances)) {
    for (const asset of Object.keys(currentBalances[addr])) {
      const balance = currentBalances[addr][asset];
      const prev = prevBalances?.[addr]?.[asset] ?? balance;
      rows.push({ address: addr, asset, balance, change: balance - prev });
    }
  }

  if (rows.length === 0) {
    return (
      <div style={{ padding: 12, fontSize: 12, color: 'var(--color-text-tertiary)' }}>
        Run a simulation to see balance changes
      </div>
    );
  }

  return (
    <table className={styles.balanceTable}>
      <thead>
        <tr>
          <th>Address</th>
          <th>Asset</th>
          <th>Balance</th>
          <th>Change</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => {
          const changeClass = r.change > 0
            ? styles.balanceIncrease
            : r.change < 0
              ? styles.balanceDecrease
              : styles.balanceNeutral;

          return (
            <tr key={i}>
              <td className={styles.addrCell} title={r.address}>{formatAddr(r.address)}</td>
              <td>{r.asset}</td>
              <td className={changeClass}>{r.balance.toLocaleString()}</td>
              <td className={changeClass}>
                {r.change > 0 ? `+${r.change.toLocaleString()}` : r.change < 0 ? r.change.toLocaleString() : '—'}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
